import { TermsState } from './state';

export const termsInitialState: TermsState = {
  terms: new Date('2022-05-17'),
  privacyPolicy: new Date('2022-05-17'),
  distributionTerms: new Date('2022-05-17'),
};
